/**
 * Property Maintenance landing page — index route for the parent menu.
 *
 * Parity: Angular `Property Maintenance` is a sidebar parent that expands
 * into Transfer / Import / Teams. Landing on the bare route in the legacy
 * app just opens the menu; here we render navigation cards so direct
 * links keep working.
 */

import { Link } from 'react-router-dom'
import { ArrowRight, Download, Upload, Users } from 'lucide-react'
import { PageShell } from '@/components/layout/PageShell'

const CARDS = [
  {
    name: 'Transfer',
    path: '/transfer-list',
    description:
      'Review and manage property transfer processes between owners, managers, and sales teams.',
    icon: Download,
  },
  {
    name: 'Import',
    path: '/import-data',
    description:
      'Bulk-load companies, properties, or residents from spreadsheets into the platform.',
    icon: Upload,
  },
  {
    name: 'Teams',
    path: '/sales-team',
    description:
      'Manage sales teams, relationship managers, and customer-success managers.',
    icon: Users,
  },
]

export function PropertyMaintenancePage() {
  return (
    <PageShell title="PROPERTY MAINTENANCE">
      <p className="text-sm text-slate-600 max-w-2xl">
        Property maintenance groups the operational tools Liberty Rent admins use
        between day-to-day application work and the global platform config. Pick
        a sub-tool below.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {CARDS.map((card) => {
          const Icon = card.icon
          return (
            <Link
              key={card.path}
              to={card.path}
              className="group rounded-lg border border-slate-200 bg-white p-5 transition-all hover:border-button-muted-border hover:shadow-md"
            >
              <div className="flex items-start justify-between">
                <div className="rounded-lg bg-button-soft p-2 text-button">
                  <Icon className="h-5 w-5" />
                </div>
                <ArrowRight className="h-4 w-4 text-slate-400 transition-colors group-hover:text-button" />
              </div>
              <h3 className="mt-4 text-base font-semibold text-slate-900">
                {card.name}
              </h3>
              <p className="mt-1 text-xs text-slate-600 leading-relaxed">
                {card.description}
              </p>
            </Link>
          )
        })}
      </div>
    </PageShell>
  )
}
